import * as React from 'react';
import classnames from 'classnames';
import { useReviewsContext } from '../../ReviewsContext/ReviewsContext.js';
import { loadReviewSnippet } from '../../ReviewsContext/actions.js';

const REVIEW_SNIPPET_ID = 'pr-review-snippet';
const ReviewSnippet = ({ productId , variantId , className  })=>{
    const { enabled , dispatch  } = useReviewsContext();
    React.useEffect(()=>{
        if (enabled && productId) {
            dispatch(loadReviewSnippet({
                id: REVIEW_SNIPPET_ID,
                productId,
                variantId
            }));
        }
    }, [
        enabled,
        productId,
        variantId
    ]);
    if (!enabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('review-snippet', className),
        "data-t": "review-snippet"
    }, /*#__PURE__*/ React.createElement("div", {
        id: REVIEW_SNIPPET_ID
    }));
};
var ReviewSnippet$1 = ReviewSnippet;

export { REVIEW_SNIPPET_ID, ReviewSnippet$1 as default };
//# sourceMappingURL=ReviewSnippet.js.map
